import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const Select = forwardRef(({
    mods,
    name,
    id,
    autoComplete,
    disabled,
    required,
    selectProps,
    options,
    onChange
}, ref) => {
    const { className } = useMods(Select, { mods });

    return (
        <select
            ref={ ref }
            name={ name }
            className={ className }
            id={ id }
            autoComplete={ autoComplete }
            required={ required }
            disabled={ disabled }
            { ...selectProps }
            onChange={ onChange }
            defaultValue=''
        >
            <option
                value=''
                disabled
            >
                { 'Select' }
            </option>
            { options.map((option, index) => (
                <option
                    key={ index }
                    value={ option.value }
                >
                    { option.name }
                </option>
            )) }
        </select>
    );
});

Select.displayName = 'Select';

Select.propTypes = {
    autoComplete: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    mods: PropTypes.object,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    required: PropTypes.bool,
    selectProps: PropTypes.object
};

Select.defaultProps = {
    disabled: false,
    mods: {},
    required: false
};

export default Select;
